import { resolvePlanSelectionFromProductId } from '~/constants/pricingPlans.js'
import { readCheckoutPlanSelection } from '~/utils/checkoutPlanSelection.js'
import {
  readPaymentReturnPending,
  readPaymentSuccessSessionId,
  normalizeQueryValue,
} from '~/utils/paymentSuccessQuery.js'

/**
 * 支付回跳：优先用 URL product_id 恢复套餐，否则回退 localStorage 选中项。
 * @param {{ route: import('vue-router').RouteLocationNormalizedLoaded, productIds?: Record<string, string> }} ctx
 */
export function resolvePaymentCallbackPlanSelection({ route, productIds = {} }) {
  const productId = normalizeQueryValue(route?.query?.product_id)
  if (productId) {
    const fromProductId = resolvePlanSelectionFromProductId(productId, productIds)
    if (fromProductId) return fromProductId
  }

  const stored = readCheckoutPlanSelection()
  if (!stored) return null

  if (productId && stored.productId && stored.productId !== productId) {
    return null
  }

  return stored
}

/**
 * 价格页首屏同步读取待恢复套餐，避免默认态 → 恢复态闪烁与多次重渲染。
 * @param {import('vue-router').RouteLocationNormalizedLoaded} route
 * @param {Record<string, string>} [productIds]
 */
export function readPendingPaymentPlanSelection(route, productIds = {}) {
  if (!import.meta.client) return null

  const fromReturn = readPaymentReturnPending()?.selection
  if (fromReturn?.tier && fromReturn?.billing) return fromReturn

  if (readPaymentSuccessSessionId(route)) {
    const fromCallback = resolvePaymentCallbackPlanSelection({ route, productIds })
    if (fromCallback) return fromCallback
  }

  return readCheckoutPlanSelection()
}
